import React, { useCallback, useEffect, useState } from "react";
import Iframe from "./Iframe.js";
const isSSR = typeof window === "undefined";
const HtmlSrcPath = "/html/2b2e4b_d767b483cae16e027c4ea8ac7906fbf4.html";
const IframeHtml = ({
  html,
  onHeightChange,
  iframeSandboxDomain,
  isViewer
}) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isIFrameLoaded, setIsIFrameLoaded] = useState(false);
  const [currId] = useState(Math.random().toString(36).substr(2, 9));
  const strippedUrl = iframeSandboxDomain.replace(/\/$/, "");
  const iframeRef = React.useRef(null);
  const handleIframeMessage = ({
    data
  }) => {
    const { type, id, height } = data;
    if (type === "htmlPlugin:heightResize" && id === currId) {
      onHeightChange(height);
    }
  };
  useEffect(() => {
    setShouldRender(true);
    !isSSR && window.addEventListener("message", handleIframeMessage);
    return () => {
      !isSSR && window.removeEventListener("message", handleIframeMessage);
    };
  }, []);
  const updateIframeContent = (content) => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: "htmlPlugin:updateContent", id: currId, content },
      "*"
    );
  };
  useEffect(() => {
    if (!isIFrameLoaded) {
      return;
    }
    updateIframeContent(html);
  }, [html, isIFrameLoaded]);
  const handleIframeLoad = useCallback(() => {
    setIsIFrameLoaded(true);
  }, []);
  return shouldRender ? /* @__PURE__ */ React.createElement(
    Iframe,
    {
      style: { backgroundColor: "transparent" },
      onLoad: handleIframeLoad,
      iframeRef,
      isViewer,
      src: strippedUrl + HtmlSrcPath
    }
  ) : null;
};
export {
  IframeHtml
};
//# sourceMappingURL=IframeHtml.js.map
